module.exports = __webpack_public_path__ + "img/wealthbottom.7165777d.png";